import { ApiClient } from '~/infrastructure/api'
import type { PublicStudyingPayload } from '~/types/lesson.types'

export function createSubmissionService(studentApiUrl: string) {
  const client = new ApiClient(studentApiUrl)

  async function createPublicStudying(payload: PublicStudyingPayload): Promise<void> {
    await client.post<unknown>('/studying/create', payload)
  }

  return { createPublicStudying }
}
